export class IdImporteDto {

  public id? : number;
  public importe? : number;
  public importePunitorio? : number;
}
